export const calculateWKg = (ftp, weightKg) => {
  if (!ftp || !weightKg || weightKg === 0) return null;
  return Number((ftp / weightKg).toFixed(2));
};
